export default __webpack_public_path__ + "static/media/dossier.4d6a1eb3.jpg";